module.exports = __webpack_public_path__ + "static/media/no-found.a7e6cce5.png";